import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import './ui.scss';

export const Modal = ({
  show,
  onClose,
  title,
  children,
  footer,
  size = 'md',
}) => {
  return (
    <BootstrapModal
      show={show}
      onHide={onClose}
      centered
      size={size === 'md' ? undefined : size}
      className="builder-ui-modal"
    >
      <BootstrapModal.Header closeButton className="builder-ui-modal__header">
        <BootstrapModal.Title className="builder-ui-modal__title">{title}</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body className="builder-ui-modal__body">{children}</BootstrapModal.Body>
      {footer && <BootstrapModal.Footer className="builder-ui-modal__footer">{footer}</BootstrapModal.Footer>}
    </BootstrapModal>
  );
};

export default Modal;
